import React from 'react';

import Popover from '@mui/material/Popover';
import { useTheme } from '@mui/material/styles';

import { defaultStyles } from '@visx/tooltip';

import { UseChartTooltipResponse } from './useChartTooltip';

export const ChartTooltip = <T extends { name: string }>({
  TooltipInPortal,
  children,
  popoverProps,
  tooltipProps,
}: {
  TooltipInPortal: UseChartTooltipResponse<T>['TooltipInPortal'];
  children: React.ReactNode;
  popoverProps: UseChartTooltipResponse<T>['popoverProps'];
  tooltipProps: UseChartTooltipResponse<T>['tooltipProps'];
}) => {
  const { palette } = useTheme();

  if (tooltipProps.open) {
    return (
      <TooltipInPortal
        left={tooltipProps.left}
        style={{
          ...defaultStyles,
          backgroundColor: palette.background.paperTertiary,
        }}
        top={tooltipProps.top}
      >
        {children}
      </TooltipInPortal>
    );
  }

  if (popoverProps.open) {
    return (
      <Popover
        anchorEl={popoverProps.anchorEl}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'center',
        }}
        open={Boolean(popoverProps.anchorEl)}
        sx={{
          pointerEvents: 'none',
        }}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'center',
        }}
      >
        {children}
      </Popover>
    );
  }

  return null;
};
